import { Outlet } from 'react-router-dom';

export default function FormPanelLayout() {
    return (
        <div className='w-screen h-screen bg-bgMain'>
            <Outlet />
        </div>
    );
}
